import { render, staticRenderFns } from "./InstantMessage.vue?vue&type=template&id=7450881c&"
import script from "./InstantMessage.vue?vue&type=script&lang=js&"
export * from "./InstantMessage.vue?vue&type=script&lang=js&"
import style0 from "./InstantMessage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports